export const VAT_PREFERENCE_COOKIE = 'vat-preference'

export type VATPreference = 'inc' | 'exc' | null

export enum TaxType {
  NoVAT = 0,
  StandardRate = 1,
  VATEvenWhenExempt = 2,
}

export function getDefaultVATPreference(countryIsoCode: string | null | undefined): VATPreference {
  if (!countryIsoCode) return null
  const code = countryIsoCode.toUpperCase()
  return code === 'GB' || code === 'UK' ? 'inc' : 'exc'
}

export function selectDisplayPrice(
  priceExcVat: number | null | undefined,
  priceIncVat: number | null | undefined,
  vatPreference: VATPreference,
  currencyCode: string | null | undefined,
  taxType: number | null | undefined
): { price: number; suffix: string | null } {
  if (!priceExcVat) {
    return { price: 0, suffix: null }
  }

  // For GBP currency, show VAT exempt suffix for zero-rated items
  if (currencyCode?.toUpperCase() === 'GBP' && taxType === TaxType.NoVAT) {
    return { price: priceExcVat, suffix: 'VAT exempt' }
  }

  // For non-GBP currencies, no VAT handling
  if (currencyCode?.toUpperCase() !== 'GBP') {
    return { price: priceExcVat, suffix: null }
  }

  if (taxType === TaxType.VATEvenWhenExempt) {
    return { price: priceIncVat ?? priceExcVat, suffix: 'inc VAT' }
  }

  if (vatPreference === 'inc' && priceIncVat) {
    return { price: priceIncVat, suffix: 'inc VAT' }
  }

  if (vatPreference === 'exc') {
    return { price: priceExcVat, suffix: 'exc VAT' }
  }

  return { price: priceExcVat, suffix: null }
}
